import { render, staticRenderFns } from "./MyRecordTab.vue?vue&type=template&id=2402038e&scoped=true&"
import script from "./MyRecordTab.vue?vue&type=script&lang=js&"
export * from "./MyRecordTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2402038e",
  null
  
)

export default component.exports